import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

function FAQs() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="privacy">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Frequently Asked Questions</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte prose max-w-none">
            <h2>Where does Petoutlet deliver?</h2>
            <p>
              We currently deliver to valid residential and commercial
              addresses in Hong Kong. See our{" "}
              <Link to="/shipping" onClick={toTop}>Shipping Policy</Link> for details.
            </p>

            <h2>How long does order processing take?</h2>
            <p>
              Orders are processed on business days. Orders received before the
              cut-off shown in our Shipping Policy are generally prepared the
              same business day; peak periods may take longer.
            </p>

            <h2>How can I track my order?</h2>
            <p>
              When tracking is available, we send the tracking reference to the
              email address supplied with your order.
            </p>

            <h2>Can I change or cancel an order?</h2>
            <p>
              Contact us as soon as possible. Cancellation requests made within
              four hours may be accepted if fulfillment has not started.
            </p>

            <h2>What is the return period?</h2>
            <p>
              Eligible items may be returned within 30 days of receipt. Review
              the <Link to="/returns" onClick={toTop}>Returns Policy</Link> before sending an item back.
            </p>

            <h2>What should I do if an item arrives damaged?</h2>
            <p>
              Photograph the product and shipping packaging, keep all materials,
              and email us promptly with your order number and a description of
              the issue.
            </p>

            <h2>How do I choose a product size?</h2>
            <p>
              Compare the listed size with your pet's measurements and intended
              use. For toys, choose a size that cannot be swallowed and supervise play.
            </p>

            <h2>Are pet toys indestructible?</h2>
            <p>
              No pet toy is indestructible. Inspect toys before each use, supervise
              play, and replace any item that becomes damaged or small enough to swallow.
            </p>

            <h2>How is my personal information handled?</h2>
            <p>
              Our <Link to="/privacy" onClick={toTop}>Privacy Policy</Link> explains
              what information we collect, why we use it, and the choices available to you.
            </p>

            <h2>How can I contact Petoutlet?</h2>
            <p>
              Email <a href="mailto:audit@petoutlet.work">audit@petoutlet.work</a>
              or visit our <Link to="/contact" onClick={toTop}>Contact page</Link>.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQs;
